"use strict";

exports.__esModule = true;
exports.useNodeBoundingRect = useNodeBoundingRect;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useNodeBoundingRect() {
  var _useState = (0, _react.useState)({
      height: 100,
      width: 100
    }),
    boundingRect = _useState[0],
    setBoundingRect = _useState[1];
  var ref = _react["default"].useCallback(function (node) {
    if (node !== null) {
      var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;
      setBoundingRect({
        width: width,
        height: height
      });
    }
  }, []);
  return Object.assign({}, boundingRect, {
    ref: ref
  });
}